import { css } from "styled-components";
import { CarouselViewport, CarouselSlides, CarouselProgressBar, CarouselControls } from "../../../..";
import { hideOnTouchDevices } from "../../../../../../skins/shared/mixins/mediaQueries";
export const riotProductSkin = (chroma, paletteTokens) => css `
  width: 100%;
  position: relative;

  ${CarouselViewport} {
    padding: ${chroma.spacers.constant.xs} ${chroma.spacers.variable.l};
    ${CarouselSlides} {
      display: flex;
      gap: ${chroma.spacers.variable.m};
    }
  }

  ${CarouselControls} {
    ${hideOnTouchDevices}
    flex-direction: column;

    ${chroma.mediaQueries.mobileDown} {
      display: none;
    }

    padding: ${chroma.spacers.variable.m} ${chroma.spacers.variable.l} 0;
    display: flex;
    justify-content: flex-end;

    .trigger-wrapper {
      display: flex;
      gap: 10px;
      align-self: flex-end;
      margin-top: 12px;

      button {
        margin: 0;
      }
    }

    ${CarouselProgressBar} {
      width: 100%;
      padding-right: 0;

      .indicator {
        transition: width 0.7s ease-out;
        background-color: ${paletteTokens.accents1};
      }

      .rail {
        margin-top: 0;
        width: 100%;
        background-color: ${paletteTokens.keyline};
      }

      flex-grow: 1;
      align-self: center;
      ${chroma.mediaQueries.mobileDown} {
        padding: ${chroma.spacers.variable.m} 0;
        height: 12px;
        width: 100%;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map